import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3"
    }, [
      _createElementVNode("path", { d: "M2 4.821v6.768a10.58 10.58 0 0 0 6.784 9.877l.925.356a2.66 2.66 0 0 0 1.915 0l.925-.356a10.59 10.59 0 0 0 6.784-9.877V4.82a1.32 1.32 0 0 0-.772-1.21A19.3 19.3 0 0 0 10.666 2a19.3 19.3 0 0 0-7.894 1.61A1.32 1.32 0 0 0 2 4.82Z" }),
      _createElementVNode("path", { d: "m7.667 11.886 1.361 1.932a.583.583 0 0 0 .948.028l4.358-5.513" })
    ], -1)
  ]))]))
}
export default { render: render }